// extracted by mini-css-extract-plugin
export default {"Voting":"Voting_Voting__NhEIJ","buttons":"Voting_buttons__REBAO","question":"Voting_question__CpHIY","LineWrapper":"Voting_LineWrapper__8+BZK"};